<!DOCTYPE html>
<html>

<head>
  <meta charset="utf-8" />
  <title>Document Download</title>
  <link href="https://fonts.googleapis.com/css2?family=Poppins&display=swap" rel="stylesheet" />

  <style>
    body {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100vh;
      margin: 0;
      font-size: 16px;
      background-color: #f2f2f2;
      font-family: "Poppins", sans-serif;
      color: #333;
    }

    .container {
      width: 50%;
      max-width: 400px;
      margin: 0 auto;
      background-color: #fff;
      padding: 20px;
      border-radius: 10px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      text-align: center;
      max-height: 300px;
      position: relative; 
      overflow: hidden;
    }

    .button_style {
      background-color: rgb(74, 11, 119);
      color: white;
      margin: 0.5rem;
      padding: 0.5rem 1rem;
      text-decoration: none;
      border-radius: 5px;
    }

    .reach-us-text {
      color: #141618;
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: -0.5px;
    }

    .reach-us-link {
      color: #991dc6;
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: -0.5px;
    }

    .button_style:hover {
      background-color: #5246b5;
    }

    .logo {
      width: 160px;
      height: auto;
      margin-bottom: 1rem;
      display: flex;
    }

   .sign-animation {
      position: absolute;
      top: 52%;
      left: 52%;
      transform: translate(-50%, -50%);
      width: 100%;
      height: 100%;
      z-index: 0;
      object-fit: contain;
      clip-path: inset(5% 5% 5% 5%);
      pointer-events: none; 
    }

    .title_five {
      text-align: center;
    }

    @media screen and (max-width: 415px) {
      .title_five {
        font-size: 17px !important;
      }

      .container {
        width: 67%;
      }
    }

    @media screen and (min-width: 415px) and (max-width: 620px) {
      .title_five {
        font-size: 1.3rem !important;
      }
      .container {
        width: 67%;
      }
    }

    @media (max-width: 768px) {
      body {
        font-size: 14px;
      }

      .button_style {
        padding: 0.8rem 1.5rem;
      }
    }

    @media (max-width: 480px) {
      body {
        font-size: 12px;
      }

      .container {
        padding: 15px;
      }

      .button_style {
        padding: 0.7rem 1.3rem;
      }
    }
  </style>
</head>

<body>
  <div class="container">
    <div style="display: flex; justify-content: center; align-items: center;">
      <img src="../../assets/img/new-logo.png" height="80" alt="Logo" class="logo" />
    </div>
      <div *ngIf="isSuccess === true">
      <img src="/assets/img/animation-crop.gif" class="sign-animation" alt="animation">
      </div>
    <div class="margin-paragraph">
      <div style="
            margin-top: 1rem;
            text-align: center;
            margin-bottom: 2rem;
            height: 20rem;
          ">
      <div *ngIf="isSuccess === false" style="display: flex; justify-content: center">
        <img src="../../../assets/img/sign-cancelled.png" height="128" />
      </div>
        <div style="display: flex; justify-content: center">
          <p *ngIf="isSuccess === false" style="padding-top: 1rem; font-size: 1.5rem; font-weight: 700;">
            Payment Failed
          </p>
          <p *ngIf="isSuccess === null"
            style="padding-top: 1rem; font-size: 1.5rem; font-weight: 700; color: rgb(61, 61, 61);">
            Processing Payment...
          </p>
        </div>

        <div *ngIf="isSuccess === true">

          <p class="title_five" style="padding-top: 1rem;color: rgb(61, 61, 61); font-size: 1.5rem; font-weight: 700">
            Payment is Successful
          </p>

          <p style="font-size: 1rem; text-align: center;margin-top: 1rem;">
            Your OrderId: <u>{{ orderId }}</u>
          </p>
          <div style="font-weight: 800; margin-top: 20px">Thank You</div>
          <p class="reach-us-text text-center my-2  ">
            Click here to<button class="reach-us-link" (click)="goToOrderList()">
              &nbsp;&nbsp; <span style="font-weight: 800;cursor: pointer;z-index: 1;position: relative;">view
                order</span>
            </button>
          </p>
        </div>

      </div>
    </div>
  </div>
</body>

</html>